
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/vanilla-js",
      function () {
        return require("private-next-pages/components/vanilla-js.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/vanilla-js"])
      });
    }
  